import { shallowEqual, useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router'

import { ISubmissionListFilterContextProps } from '@context/SubmissionListFilter'
import { withSubmissionListFilter } from '@hocs'
import { IApplicationState } from '@store'
import { selectIsUnlockedCampaign } from '@store/campaigns'
import { selectCampaignId } from '@store/router'
import { selectFilteredSubmissionsSortOptions } from '@store/submissions'
import SubmissionSortWrapper from './SortWrapper'

const financialOptions = ['estimated_cpe', 'cpe', 'price']

const SubmissionSortTiles = ({ filter }: ISubmissionListFilterContextProps) => {
  const match = useRouteMatch()
  const campaignId = selectCampaignId(match) as number
  const { sortOptionsLink, isUnlockedCampaign } = useSelector((state: IApplicationState) => ({
    sortOptionsLink: selectFilteredSubmissionsSortOptions(state, campaignId, filter),
    isUnlockedCampaign: selectIsUnlockedCampaign(state, campaignId),
  }), shallowEqual)
  let sortOptions = sortOptionsLink && (sortOptionsLink.sort_by as string[])

  if (isUnlockedCampaign && sortOptions) {
    sortOptions = sortOptions.filter((option) => !financialOptions.includes(option))
  }

  return (
    <SubmissionSortWrapper campaignId={campaignId} sortOptions={sortOptions ?? ([] as string[])} />
  )
}

export default withSubmissionListFilter(SubmissionSortTiles)
